"use client"
import { Content } from "@prismicio/client"
import { SliceComponentProps } from "@prismicio/react"

import Default from "./default"
import WithTimeline from "./withTimeline"

/**
 * Props for `Text`.
 */
export type DynamicDocumentsProps =
  SliceComponentProps<Content.DynamicDocumentsSlice>

/**
 * Component for "Text" Slices.
 */
const DynamicDocuments = ({
  slice,
  ...props
}: DynamicDocumentsProps): JSX.Element => {
  switch (slice.variation) {
    case "default":
      return <Default slice={slice} {...props} />
    case "withTimeline":
      return <WithTimeline slice={slice} {...props} />
  }
}

export default DynamicDocuments
